module.exports = __webpack_public_path__ + "static/img/sichegongyongshenqing.3e30af11.png";